import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelText as _vModelText, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "vcomment" }
const _hoisted_2 = {
  key: 0,
  class: "vlogin-info"
}
const _hoisted_3 = { class: "vavatar" }
const _hoisted_4 = ["title"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "vpanel" }
const _hoisted_8 = ["for", "textContent"]
const _hoisted_9 = ["id", "name", "type", "onUpdate:modelValue"]
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "vfooter" }
const _hoisted_13 = { class: "vactions" }
const _hoisted_14 = {
  href: "https://guides.github.com/features/mastering-markdown/",
  title: "Markdown Guide",
  "aria-label": "Markdown is supported",
  class: "vaction",
  target: "_blank",
  rel: "noreferrer"
}
const _hoisted_15 = ["title"]
const _hoisted_16 = ["title"]
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "vinfo" }
const _hoisted_19 = { class: "vtext-number" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("  /  ")
const _hoisted_22 = ["textContent"]
const _hoisted_23 = ["textContent"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 0,
  class: "vtab-wrapper"
}
const _hoisted_26 = ["title", "onClick"]
const _hoisted_27 = ["src", "alt"]
const _hoisted_28 = {
  key: 0,
  class: "vtabs"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["src", "alt", "title"]
const _hoisted_31 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseIcon = _resolveComponent("CloseIcon")!
  const _component_MarkdownIcon = _resolveComponent("MarkdownIcon")!
  const _component_EmojiIcon = _resolveComponent("EmojiIcon")!
  const _component_ImageIcon = _resolveComponent("ImageIcon")!
  const _component_PreviewIcon = _resolveComponent("PreviewIcon")!
  const _component_LoadingIcon = _resolveComponent("LoadingIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.config.login !== 'disable' && _ctx.isLogin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "vlogout-btn",
              title: _ctx.locale.logout,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLogout && _ctx.onLogout(...args)))
            }, [
              _createVNode(_component_CloseIcon, { size: "14" })
            ], 8 /* PROPS */, _hoisted_4),
            _createElementVNode("img", {
              src: 
            _ctx.userInfo.avatar ||
            `${_ctx.config.avatar.cdn}${_ctx.userInfo.mailMd5}${_ctx.config.avatar.param}`
          ,
              alt: "avatar"
            }, null, 8 /* PROPS */, _hoisted_5)
          ]),
          _createElementVNode("a", {
            href: "#",
            class: "vlogin-nick",
            "aria-label": "Profile",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onProfile && _ctx.onProfile(...args))),
            textContent: _toDisplayString(_ctx.userInfo.display_name)
          }, null, 8 /* PROPS */, _hoisted_6)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.config.login !== 'force' && _ctx.config.meta.length && !_ctx.isLogin)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['vheader', `vheader-${_ctx.config.meta.length}`])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.meta, (kind) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "vheader-item",
                key: kind
              }, [
                _createElementVNode("label", {
                  for: kind,
                  textContent: _toDisplayString(
              _ctx.locale[kind] +
              (_ctx.config.requiredMeta.includes(kind) || !_ctx.config.requiredMeta.length
                ? ''
                : `(${_ctx.locale.optional})`)
            )
                }, null, 8 /* PROPS */, _hoisted_8),
                _withDirectives(_createElementVNode("input", {
                  ref_for: true,
                  ref: 
              (element) => {
                if (element) _ctx.inputRefs[kind] = element;
              }
            ,
                  id: `waline-${kind}`,
                  class: _normalizeClass(['vinput', `v${kind}`]),
                  name: kind,
                  type: kind === 'mail' ? 'email' : 'text',
                  "onUpdate:modelValue": ($event: any) => ((_ctx.inputs[kind]) = $event)
                }, null, 10 /* CLASS, PROPS */, _hoisted_9), [
                  [_vModelDynamic, _ctx.inputs[kind]]
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true),
      _withDirectives(_createElementVNode("textarea", {
        class: "veditor",
        ref: "editorRef",
        id: "waline-edit",
        placeholder: _ctx.replyUser ? `@${_ctx.replyUser}` : _ctx.locale.placeholder,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputs.editor) = $event)),
        onKeydown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onKeyDown && _ctx.onKeyDown(...args))),
        onDrop: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args))),
        onPaste: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onPaste && _ctx.onPaste(...args)))
      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_10), [
        [_vModelText, _ctx.inputs.editor]
      ]),
      _createElementVNode("div", {
        class: "vpreview",
        style: _normalizeStyle({ display: _ctx.showPreview ? 'block' : 'none' })
      }, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.locale.preview) + ":", 1 /* TEXT */),
        _createElementVNode("div", {
          class: "vcontent",
          innerHTML: _ctx.previewText
        }, null, 8 /* PROPS */, _hoisted_11)
      ], 4 /* STYLE */),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("a", _hoisted_14, [
            _createVNode(_component_MarkdownIcon)
          ]),
          _createElementVNode("button", {
            ref: "emojiButtonRef",
            class: _normalizeClass(["vaction", { actived: _ctx.showEmoji }]),
            title: _ctx.locale.emoji,
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showEmoji = !_ctx.showEmoji))
          }, [
            _createVNode(_component_EmojiIcon)
          ], 10 /* CLASS, PROPS */, _hoisted_15),
          _createElementVNode("input", {
            ref: "imageUploadRef",
            class: "upload",
            id: "waline-image-upload",
            type: "file",
            accept: ".png,.jpg,.jpeg,.webp,.bmp,.gif",
            onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
          }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */),
          (_ctx.canUploadImage)
            ? (_openBlock(), _createElementBlock("label", {
                key: 0,
                for: "waline-image-upload",
                class: "vaction",
                title: _ctx.locale.uploadImage
              }, [
                _createVNode(_component_ImageIcon)
              ], 8 /* PROPS */, _hoisted_16))
            : _createCommentVNode("v-if", true),
          _createElementVNode("button", {
            class: _normalizeClass(["vaction", { actived: _ctx.showPreview }]),
            title: _ctx.locale.preview,
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showPreview = !_ctx.showPreview))
          }, [
            _createVNode(_component_PreviewIcon)
          ], 10 /* CLASS, PROPS */, _hoisted_17)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createTextVNode(_toDisplayString(_ctx.wordNumber) + " ", 1 /* TEXT */),
            (_ctx.config.wordLimit)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("span", {
                    class: _normalizeClass({ illegal: !_ctx.isWordNumberLegal }),
                    textContent: _toDisplayString(_ctx.wordLimit)
                  }, null, 10 /* CLASS, PROPS */, _hoisted_22)
                ]))
              : _createCommentVNode("v-if", true),
            _createTextVNode("  " + _toDisplayString(_ctx.locale.word), 1 /* TEXT */)
          ]),
          (_ctx.config.login !== 'disable' && !_ctx.isLogin)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "vbtn",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onLogin && _ctx.onLogin(...args))),
                textContent: _toDisplayString(_ctx.locale.login)
              }, null, 8 /* PROPS */, _hoisted_23))
            : _createCommentVNode("v-if", true),
          (_ctx.config.login !== 'force' || _ctx.isLogin)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "vbtn primary",
                title: "Cmd|Ctrl + Enter",
                disabled: _ctx.isSubmitting,
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.submitComment && _ctx.submitComment(...args)))
              }, [
                (_ctx.isSubmitting)
                  ? (_openBlock(), _createBlock(_component_LoadingIcon, {
                      key: 0,
                      size: 16
                    }))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.locale.submit), 1 /* TEXT */)
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
              ], 8 /* PROPS */, _hoisted_24))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", {
          ref: "emojiPopupRef",
          class: _normalizeClass(["vemoji-popup", { display: _ctx.showEmoji }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emoji.tabs, (config, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: config.name
            }, [
              (index === _ctx.emojiTabIndex)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.items, (key) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: key,
                        title: key,
                        onClick: ($event: any) => (_ctx.insert(`:${key}:`))
                      }, [
                        (_ctx.showEmoji)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "vemoji",
                              src: _ctx.emoji.map[key],
                              alt: key,
                              loading: "lazy",
                              referrerPolicy: "no-referrer"
                            }, null, 8 /* PROPS */, _hoisted_27))
                          : _createCommentVNode("v-if", true)
                      ], 8 /* PROPS */, _hoisted_26))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */)),
          (_ctx.emoji.tabs.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emoji.tabs, (config, index) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: config.name,
                    class: _normalizeClass(["vtab", { active: _ctx.emojiTabIndex === index }]),
                    onClick: ($event: any) => (_ctx.emojiTabIndex = index)
                  }, [
                    _createElementVNode("img", {
                      class: "vemoji",
                      src: config.icon,
                      alt: config.name,
                      title: config.name,
                      loading: "lazy",
                      referrerPolicy: "no-referrer"
                    }, null, 8 /* PROPS */, _hoisted_30)
                  ], 10 /* CLASS, PROPS */, _hoisted_29))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */)
      ])
    ]),
    (_ctx.replyId)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "vclose",
          title: _ctx.locale.cancelReply,
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('cancel-reply')))
        }, [
          _createVNode(_component_CloseIcon, { size: "24" })
        ], 8 /* PROPS */, _hoisted_31))
      : _createCommentVNode("v-if", true)
  ]))
}